// extracted by mini-css-extract-plugin
export default {"form":"profile-form_form__XpHqT","buttons_container":"profile-form_buttons_container__T9sGl"};